<template>
    <div class="conference_main_box">
        <user-info-popup :meetingID="roomId" v-if="userInfoStorePopup"></user-info-popup>
        <meetingGuard v-else :room-id="roomId" :meetingType="'public'" :userInfo="userInfo"></meetingGuard>
    </div>
</template>

<script>
/*eslint-disable */
import { bus } from "@/main";
import userInfoForConf from '@/components/private/user-info-for-conference/';
import meetingGuard from '@/components/private/jitsi/meetingGuard';
export default {
    name: 'public-meeting-conf',
    components: {
        'user-info-popup': userInfoForConf,
         meetingGuard
    },
    props: [],
    data() {
        return {
            roomId: '',
            userInfo: null,
            userInfoStorePopup: true,
        }
    },
    mounted() {
        bus.$on('userInfoStoreBus', this.handleUserInfoStore);
        bus.$on('meetingStartAlert', this.handleMeetingStart);

        if (!location.hash) {
            location.hash = Math.floor(Math.random() * 0xFFFFFF).toString(16);
        }
        this.roomId = location.hash.substring(1);
    },
    methods: {
        handleUserInfoStore(data) {
            this.userInfoStorePopup = data;
        },
        handleMeetingStart(data) {
            this.userInfo = data;
        },
    },
    beforeDestroy() {
        bus.$off('userInfoStoreBus', this.handleUserInfoStore);
        bus.$off('meetingStartAlert', this.handleMeetingStart);
    },
    beforeCreate: function () {
        document.body.classList.add('dashboard');
        document.body.classList.add('video_conference_page');
    },
    beforeRouteLeave: function (to, from, next) {
        document.body.classList.remove('dashboard');
        document.body.classList.remove('video_conference_page');
        next();
    },
}
</script>